import { dashNotifications } from "api"
import _debounce from 'lodash.debounce'
import _cloneDeep from 'lodash.clonedeep'

const { default: types } = require("./types")

// display all notification types
const TOTAL_TYPES = 4

const getNotificationsAct = (notifications=[])=>({ type: types.DASH_NOTIFICATIONS_GET_SUCCESS, notifications })
const getNotificationsActStart = ()=>({ type: types.DASH_NOTIFICATIONS_GET_START, })
const getNotificationsActFailure = ()=>({ type: types.DASH_NOTIFICATIONS_GET_FAILURE })

const changeGetMore = (getMore) => ({ type: types.DASH_NOTIFICATIONS_GETMORE, getMore })

const getNotifications = async (filters) => {
  const { data } = await dashNotifications.getNotifications({
    ...filters,
    type: filters.type?.length === TOTAL_TYPES ? [] : filters.type
  })
  return data
}

const getNotificationsDash = (concat=false) => {
  return async (dispatch, getState)=>{
    const { dashNotifications:{ filters, notifications, loading } } = getState()
    try {
      if(loading) return
      if(filters.type.length === 0){
        dispatch(getNotificationsAct([]))
        dispatch(changeGetMore(true))
        return
      }
      dispatch(getNotificationsActStart())
      const data = await getNotifications(filters)
      if(concat){
        dispatch(getNotificationsAct([...notifications, ...data]))
      }else{
        dispatch(getNotificationsAct([...data]))
      }
      if(data.length < filters.limit){
        dispatch(changeGetMore(false))
      }else{
        dispatch(changeGetMore(true))
      }
    } catch (error) {
      dispatch(getNotificationsActFailure())
    }
  }
}

const callBounceClear = _debounce((dispatch)=>{
  dispatch({ type: types.DASH_NOTIFICATIONS_CLEAR })
}, 256)

const clearNotification = () => (dispatch)=>{
  callBounceClear(dispatch)
}

const updateFilters = (filterUpdate, concat = false) => {
  return (dispatch, getState) => {
    const { dashNotifications: { filters } } = getState()
    dispatch({ type: types.DASH_NOTIFICATIONS_UPDATE_FILTERS, filterUpdate })
    if(filters !== filterUpdate){
      dispatch(getNotificationsDash(concat))
    }
  }}

const updatePage = (concat) => {
  return (dispatch, getState) => {
    const { dashNotifications: { filters, getMore, loading } } = getState()
    if(getMore && !loading){
      dispatch(updateFilters({ ...filters, page: filters.page + 1 }, concat))
    }
  }
}

/**
 *
 * @param {object} data
 * @param {string} data.notificationId
 * @param {boolean} data.isRead
 */
const updateRead = (data) =>{
  return async (dispatch, getState) => {
    const { dashNotifications: { notifications, filters } } = getState()
    const cloneNotifications = _cloneDeep(notifications)
    const notification = notifications.find(notification => notification._id === data.notificationId)
    if(notification && notification.isRead === data.isRead) return
    try {
      let newNotifications = markReadNotification(_cloneDeep(notifications), data)
      if(filters.display !== 'all'){
        newNotifications = verifyDisplayFilters(newNotifications, filters.display)
      }
      dispatch(updateReadAct(newNotifications))
      const result = await dashNotifications.markRead(data)
      if(result.status === 200){
        return 'ok'
      }
    } catch (error) {
      dispatch(updateReadAct(cloneNotifications))
      return 'error'
    }
  }
}

const markReadNotification = (notifications, data) =>{
  return notifications.map((notification) => {
    if(notification._id === data.notificationId || data.notificationId === 'all'){
      notification.isRead = data.isRead
    }
    return notification
  })
}

const verifyDisplayFilters = (newNotifications, display) => {
  let newNot = []
  if(display === 'read'){
    newNot = newNotifications.filter((notification) => notification.isRead )
  }else if(display === 'unread'){
    newNot = newNotifications.filter((notification) => !notification.isRead )
  }
  return newNot
}

const updateReadAct = (notifications=[]) => ({ type: types.DASH_NOTIFICATIONS_UPDATE_READ, notifications })

const updateHasAndTotal = (hasNotification, total) => ({
  type: types.DASH_NOTIFICATIONS_UPDATE_HAS_TOTAL, hasNotification, total
})

const verifyNotifications = (notifications = []) => {
  return (dispatch) => {
    const unread = notifications.some(notification => !notification.isRead)
    dispatch(updateHasAndTotal(unread, 0))
  }
}

const getHasNew = (isGetNotifications = false, notificationId) => {
  return async (dispatch, getState) => {
    try {
      const { dashNotifications: { notifications, filters, isOpen } } = getState()
      const { data } = await dashNotifications.getInformationForNotification()
      if(!data.hasNotification) return
      dispatch(updateHasAndTotal(data.hasNotification, data.total))
      if(isGetNotifications && notificationId && isOpen){
        const dataNotifications = await getNotifications({ ...filters, page: 0 })
        const notification = dataNotifications.find(no => no._id === notificationId)
        if(notification){
          dispatch(getNotificationsAct([notification, ...notifications]))
        }
      }

    } catch (error) {
      return error
    }
  }
}

const setIsOpen = (isOpen) => ({
  type: types.DASH_NOTIFICATIONS_ISOPEN, isOpen
})

export default {
  getNotificationsDash,
  clearNotification,
  updateFilters,
  updatePage,
  updateRead,
  verifyNotifications,
  getHasNew,
  setIsOpen
}